import React from 'react'
import { Row, Col } from 'reactstrap';
import { Redirect, Switch, Route } from "react-router-dom";
import { MenuDasFuncionalidades } from "../Menu/index";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import { CardCrud } from '../Conteudo/Cards/index';
import { convertToSlug } from '../Basicos/funcoes';

function Tema({temas, }) {
    
    return (
        <Row noGutters={true}>
            <MenuDasFuncionalidades
                funcionalidade={"Temas"}
                classNavBar="navbar-consultas"
                titulo="Temas"
            />
            <Col sm={12} md={12} className="col-conteudo">
                <Switch>
                    {temas.map((subFuncionalidade, indice) => {
                        switch (convertToSlug(subFuncionalidade.descricao)) {
                            case "auxiliares":
                                return null;
                            default:
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => 
                                            <CardCrud 
                                                {...props}
                                                subFuncionalidade={subFuncionalidade}
                                                indiceSubFuncionalidade={indice}
                                                funcionalidade={"temas"}
                                            />
                                        }
                                    />
                                );
                        }
                    })}
                    <Route render={() => <Redirect to="/" />} />
                </Switch>
            </Col>
        </Row>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        desativarModal: () => dispatch(actionsRedux.desativarModalSubFuncionalidade()),
    }
}

const mapStateToProps = (state) => {
    return {
        temas: state.subFuncionalidades.temas,
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        adicionar: state.subFuncionalidades.adicionar,
        editarFunc: state.subFuncionalidades.editar,
        tipoAcao: state.subFuncionalidades.tipoAcao,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tema)
